import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 32px;
  background: ${props => props.theme.colors.background.lightest};
  margin-top: ${props => props.theme.spacing(4)};
  width: 100%;
  position: relative;
  @media ${props => props.theme.laptop} {
    display: flex;
    flex-direction: row;
  }
`;

export const DateInfo = styled.div`
  padding-top: ${props => props.theme.spacing(8)};
  text-align: center;
  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(10, 2)};
    max-width: 347px;
    width: 100%;
  }
`;

export const Contents = styled.div`
  padding: ${props => props.theme.spacing(10, 0, 8)};
  text-align: center;
  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(10, 0)};
    flex: 1;
    text-align: left;
  }
`;

export const ArrivalText = styled.p`
  ${props => props.theme.typography.heading4};
  margin: ${props => props.theme.spacing(4, 0, 2)};
`;

export const IncludedText = styled.p`
  ${props => props.theme.typography.heading4};
  margin-bottom: ${props => props.theme.spacing(2)};
`;

export const SubText = styled.p`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.secondary};
`;

export const ChangeNotAllowedText = styled.button`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.status.warningPrimary};
  background: none;
  border: none;
  padding: 0;
`;

export const ChangeNotAllowedTip = styled.div`
  text-align: center;
  max-width: 300px;
  a {
    color: white;
    text-decoration: underline;
  }
`;

export const OrderDetailsButton = styled.button`
  ${props => props.theme.typography.button}
  color: ${props => props.theme.colors.hero.blueberry};
  background: none;
  border: none;
  padding: 0;
  margin-top: ${props => props.theme.spacing(5)};
`;

export const RecipeCount = styled.p`
  ${props => props.theme.typography.body};
  margin-bottom: ${props => props.theme.spacing(6)};
  @media ${props => props.theme.laptop} {
    margin-top: ${props => props.theme.spacing(4)};
    margin-bottom: ${props => props.theme.spacing(4)};
  }
`;

export const EditAnchor = styled.a`
  color: ${props => props.theme.colors.hero.blueberry};
  margin-left: ${props => props.theme.spacing(2)};
`;

export const RecipeImageContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${props => props.theme.spacing(8)};
  justify-content: center;
  @media ${props => props.theme.laptop} {
    display: block;
  }
`;

export const RecipeImage = styled.span`
  @media ${props => props.theme.laptop} {
    margin: ${props => props.theme.spacing(0, 8, 8, 0)};
  }
`;
